import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'

export default function Header() {
  const { user } = useAuth()
  const navigate = useNavigate()

  return (
    <header style={{ paddingTop: 'env(safe-area-inset-top)', background: 'transparent' }}>
      <div className="flex items-center justify-between px-6 py-4 border-t border-b border-gray-300">
        <button
          type="button"
          onClick={() => navigate('/')}
          aria-label="Go to home"
          className="cursor-pointer rounded focus:outline-none focus:ring-2 focus:ring-gray-400"
        >
          <img src="/logo.png" alt="N of 1" className="h-12 w-auto" style={{ mixBlendMode: 'multiply' }} />
        </button>
        <div className="flex items-center gap-4">
          <span className="text-sm text-gray-600">{user?.email}</span>
          <button
            type="button"
            onClick={() => supabase.auth.signOut()}
            className="text-sm text-gray-500 hover:text-gray-900 rounded px-1 focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  )
}
